import React from 'react';
import './styles.css';
import { connect } from 'react-redux';
import {
    loadDrivers,
    addDriver,
    setDriverFilters,
    exportToCsvOrExcel,
} from '../../../../../redux/modules/vendors';
import ImportDriversFromFile from './import_drivers';
import DriverList from './driver_list';
import IconPlus from '../../../../icons/plus';
import DriverForm from "../forms/driver";
import Modal from './modal';
import IconDownload from "../../../../icons/download";
import IconAngleLeft from "../../../../icons/angleLeftIcon";
import Pagination from '../../../Utils/pagination';
import Filters from './filters';
import VendorHeader from './header';


const VendorDetails = (props) => {
    const {
        match: { params: { id } },
        history,
        drivers_page = 1,
        loadDrivers,
        addDriver,
        driver_filters,
        setDriverFilters,
        drivers,
        exportToCsvOrExcel,
    } = props;

    const [modalCreate, setModalCreate] = React.useState(false);
    
    const onChangeFilter = (filters = {}) => {
        setDriverFilters(filters);
    }

    const onOpenModalCreate = () => {
        setModalCreate(true);
    }

    const onCloseModalCreate = () => {
        setModalCreate(false);
    }

    const onSubmitDriverForm = async (values) => {
        const driver_data = JSON.parse(JSON.stringify(values));
        if (driver_data.auto_generate)
            delete driver_data.password;

        delete driver_data.auto_generate;
        const response = await addDriver({
            ...driver_data,
            vendor_id: id,
        });
        if (response) {
            setModalCreate(false);
        }
    }

    const onDownloadDriverList = async () => {
        await exportToCsvOrExcel('csv', false);
    }

    const onExportCsv = async () => {
        await exportToCsvOrExcel('csv');
    }

    const onExportExcel = async () => {
        await exportToCsvOrExcel('excel');
    }

    const goBack = () => {
        history.goBack();
    }
    
    return (
        <div className="vendor-details">
            <Modal
                open={modalCreate}
                onClose={() => onCloseModalCreate()}
                styles={{
                    modal: { borderRadius: 12, maxWidth: 800 }
                }}
            >
                <Modal.Header title="Add New Driver" />
                <div className="p-4">
                    <DriverForm
                        showBtns={false}
                        id="driver-update-form"
                        onSubmit={onSubmitDriverForm}
                        initialValues={{
                            auto_generate: true,
                            user_type: "admin",
                            role: "driver"
                        }}
                    />
                </div>
                <Modal.Footer idForm="driver-update-form" confirmText="Send Invite" />
            </Modal>
            <div className="d-flex align-items-center justify-content-between mb-3"
                onClick={goBack}
            >
                <div className="d-flex align-items-center text-primary clickable">
                    <IconAngleLeft className="vendor-icon" />
                    <span className="fw-600 h6 mb-0 ml-2"> Back to Vendors </span>
                </div>
            </div>
            <VendorHeader id={id} />
            <div className="d-flex justify-content-between mb-3">
                <div className="d-flex align-items-center">
                    <h4 className="mb-0">Drivers & Admins</h4>
                    {drivers && (
                        <div className="ml-2">
                            <span className="badge badge-pill badge-danger">
                                {drivers.count}
                            </span>
                        </div>
                    )}
                </div>
                <div className="d-flex" style={{ gap: 10 }}>
                    <button type="button" className="btn-hover d-flex align-items-center"
                        onClick={onDownloadDriverList}
                    >
                        <IconDownload className="vendor-icon" />
                        <span className="h6 mb-0 ml-2">Download Driver List</span>
                    </button>
                    <ImportDriversFromFile
                        vendor_id={id}
                    />
                    <button
                        type="button"
                        className="btn btn-primary d-flex align-items-center"
                        onClick={onOpenModalCreate}
                    >
                        <IconPlus className="vendor-icon" />
                        <span className="h6 fw-600 mb-0 ml-2">Add</span>
                    </button>
                </div>
            </div>
            <div className="mb-3">
                <Filters
                    onChange={onChangeFilter}
                    filters={driver_filters}
                    onExportCsv={onExportCsv}
                    onExportExcel={onExportExcel}
                />
            </div>
            <div className="mb-2">
                <DriverList
                    vendor_id={id}
                />
            </div>
            {drivers && drivers.results && drivers.results.length > 0 && (
                <div className="header-card p-4 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        <span className="text-muted"
                            style={{ fontSize: "85%" }}
                        >
                            Showing {
                                ((drivers_page - 1) * 10) + 1
                            }-{
                                ((drivers_page - 1) * 10) + drivers.results.length
                            } of {drivers.count} users
                        </span>
                    </div>
                    <div style={{ fontSize: "0.85rem" }}>
                        <Pagination
                            total={drivers.count}
                            page={drivers_page}
                            find={(page)=>loadDrivers({}, page)}
                            itemsPerPage={10}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

const mstp = (state) => ({
    ...state.vendors
})

const mdtp = {
    setDriverFilters,
    loadDrivers,
    addDriver,
    exportToCsvOrExcel,
}

export default connect(mstp, mdtp)(VendorDetails);
